import React from 'react'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import { useCommunity } from 'utils'
import { ExternalLink } from 'components'

const propTypes = {}

const defaultProps = {}

function NotContributorInfoNote() {
  const community = useCommunity()
  return (
    <section>
      <div className="content-block-container">
        <p className="neutral-callout">
          This school has not yet joined the artlook® SWPA network as a
          contributor. If you're a staff member at this school and would like to
          start sharing information about your arts education programs and
          partnerships, please contact us at{' '}
          <ExternalLink href={`mailto:${community.partnerSupportEmail}`}>
            {community.partnerSupportEmail}
          </ExternalLink>
          .
        </p>
      </div>
    </section>
  )
}

NotContributorInfoNote.propTypes = exact(propTypes)
NotContributorInfoNote.defaultProps = defaultProps

export default pure(NotContributorInfoNote)
